import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function EFReplyIcon() {
  const isDark = useAppSelector(isDarkTheme)
  const fill = isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.2773 16.2211C9.57 16.5142 9.56967 16.9891 9.27658 17.2818C8.98349 17.5745 8.50861 17.5742 8.21592 17.2811L3.21931 12.2776C2.92678 11.9847 2.92692 11.5101 3.21962 11.2174L8.21623 6.21972C8.50909 5.9268 8.98396 5.92675 9.27689 6.21962C9.56981 6.51248 9.56986 6.98735 9.277 7.28028L5.557 11H13.3988C14.9936 11 16.2099 11.242 17.2878 11.7645L17.5342 11.89C18.6427 12.4829 19.5171 13.3573 20.11 14.4658C20.7194 15.6053 21 16.8837 21 18.6012C21 19.0154 20.6642 19.3512 20.25 19.3512C19.8358 19.3512 19.5 19.0154 19.5 18.6012C19.5 17.1174 19.2723 16.0802 18.7872 15.1732C18.3342 14.3261 17.6739 13.6658 16.8268 13.2128C15.9895 12.765 15.0414 12.5365 13.7334 12.5041L13.3988 12.5H5.562L9.2773 16.2211Z'
        fill={fill}
      />
    </svg>
  )
}
